import { JSX } from 'react';
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    ExportButton,
    Datagrid,
    EditButton,
    SelectField,
    SearchInput
} from 'react-admin';
import { nokStatus } from "../../defaults/defaults";
import { CsvImportButton } from "../import/CsvImportButton";
import { CsvExportForImportButton } from "../import/CsvExportForImportButton";
import { nokWebsiteImport } from "../import/configs/nokWebsiteImport";

// A name search, as the other HQ lists have; HQ-API's `name` filter is a partial match.
const ListFilters: JSX.Element[] = [
    <SearchInput key="name" source="name" alwaysOn />,
];

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            {/* Was isAdmin, which showed this button to ROLE_ADMIN while HQ-API held the write to
                super admin and above, so an admin got a create form the POST then refused.
                HQ_Nok::faux_nokkers is the API's own tier, which closes the gap. */}
                <CreateButton />
                <CsvImportButton config={ nokWebsiteImport } />
                <CsvExportForImportButton config={ nokWebsiteImport } />
            {/*<FilterButton />*/}
            <ExportButton />
        </TopToolbar>
    );
}

export const NokWebsiteList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={<ListActions/>}
            filters={ ListFilters }
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="soloOrCompany" />
                <SelectField source="status" choices={nokStatus} />
                <EditButton />
            </Datagrid>
        </List>
    );
}
